import { styled } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';

export const StyledWrapperStack = styled(Stack)(({ theme }) => ({
  textAlign: 'center',
  alignItems: 'center',
  width: '100%',
  gap: theme.spacing(6),
}));

export const StyledGrid = styled(Grid2)(({ theme }) => ({
  flexDirection: 'column',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    marginBlockStart: theme.spacing(12),
    flexDirection: 'row',
  },
}));

export const StyledContainerStack = styled(Stack)(() => ({
  alignItems: 'center',
  width: '100%',
  overflow: 'auto',
}));
